import React from 'react';
import './about.css';

// ================= DATA OBJECT =================

const aboutUsData = {
  title: "ग्रामपंचायत धाकटी-डहाणू: प्रगतीचा संकल्प",

  intro:"धाकटीला डहाणूहे डहाणू तालुक्यातील संपूर्ण समुद्रकिनारी वसलेले संस्कृती कृषी मच्छीमार कोळी समाज व बागायतदारांचे तसेच अनुसूचित जमातीचे मिश्रण असलेले नांदणारे उत्तम उदाहरण असलेले गाव, हे गाव एक आदर्श आत्मनिर्भर आणि तंत्रज्ञान स्नेही गाव बनविण्यासाठी कटिबंध आहोत",

  // ================= VISION =================
  visionTitle: "💡 आमची दृष्टी (Our Vision)",
  vision: [
    { icon: "🌐", title: "डिजिटल ग्राम", description: "ग्रामपंचायतीचे कामकाज पारदर्शक आणि डिजिटल माध्यमांतून चालवणे." },
    { icon: "🌿", title: "पर्यावरण पूरक विकास", description: "गावातील स्वच्छता, पाणी व्यवस्थापन आणि नैसर्गिक संसाधनांचे संरक्षण करणे." },
    { icon: "🤝", title: "युवा आणि महिला सबलीकरण", description: "शिक्षण, आरोग्य आणि रोजगाराच्या संधी उपलब्ध करून तरुण आणि महिलांना सशक्त करणे." },
  ],

  // ================= SERVICES =================
  servicesTitle: "🏗 सेवा आणि सुविधा",
  services: [
    "गावात दोन मच्छिमार सहकारी सोसायटी आहेत.",
    "    1) धाकटी डहाणू मच्छीमार सहकारी सोसायटी .",
    "    2) गुंगवाडा मच्छीमार सहकारी सोसायटी .",
    " गावात आईस फॅक्टरी आहे .",
    "  दोन बँका आहेत.",
    "एक ठाणे जिल्हा मध्यवर्ती सहकारी बँक ",
    " एक स्टेट बँक .",
    "आरोग्य उपकेंद्र आहे.",
    "पायाभूत सुविधा: उत्तम रस्ते, पाणीपुरवठा आणि सार्वजनिक बांधकाम.",
    "दाखले आणि नोंदी: जन्म-मृत्यू, रहिवासी दाखले वेळेत देणे.",
    "शासकीय योजना: शासनाच्या योजनांचा लाभ नागरिकांपर्यंत पोहोचवणे.",
    
  ],

  //  servicesTitle: "🏗 गावात नसणाऱ्या सुविधा",
  // services: [
  //   "दाखल्यामध्ये नॉन क्रिमिनल, जात प्रमाणपत्र ,प्रतिज्ञापत्र, उत्पन्न प्रमाणपत्र ,महसूल विभागाकडून देतात ग्रामपंचायत नाही .",
  //   "गावात आरो पाणी नाही .",
  //   "माता मंदिर नाही.",
  //   " पेवर ब्लॉक चा फोटो मध्ये डबल फोटो आहे.",
  // ],
  // ================= GRAM PANCHAYAT INFO (Updated with address & email) =================
  gramPanchayatInfo: {
    title: "📄 ग्रामपंचायतीची माहिती",
    details: [
      "ग्रामपंचायतीचे नाव : धाकटी-डहाणू",
      "तालुका : डहाणू",
      "जिल्हा : पालघर",
      "स्थापना वर्ष : 1962",
      "प्रशासक : श्री राजेंद्र पांडुरंग पाटील",
      "ग्रामपंचायत अधिकारी : सौ तनुजा राजेंद्र सावे",
      "कार्यालय संपर्क : ",
      "ईमेल :vpdhakatidahanu@gmail.com",
      "पत्ता : ग्रामपंचायत धाकटी-डहाणू, मु.पो. धाकटी-डहाणू, ता.डहाणू जि. पालघर, महाराष्ट्र, पिन - ४०११०२"
    ]
  },

  // ================= NEW FACILITIES (Population + School + Health + Anganwadi) =================
  facilities: {
    title: "🏘 गावातील मुख्य सुविधा",
    population: "5678",
    male:"2799", 
    female:"2879",
    school: " जि. प. केंद्र शाळा धाकटी-डहाणू",
    healthCenter: " प्राथमिक आरोग्य केंद्र धाकटी-डहाणू",
    anganwadi: [
      "अंगणवाडी धाकटी-डहाणू केंद्र ",
     
    ]
  },

  // ================= OTHER SECTIONS =================
  education: {
    title: "📚 शिक्षण व्यवस्था",
    content: [
      "जिल्हा परिषद शाळा कार्यरत आहे.",
      "इयत्ता 1 ली ते 5 वी पर्यंत शिक्षण उपलब्ध आहे.",
      "शाळेत परसबाग विहीर खेळाचे मैदान आहे.",
      "मोफत पुस्तके, गणवेश व शिष्यवृत्ती दिली जाते.",
      "शाळेत पिण्याचे पाणी व स्वच्छतागृह सुविधा आहे.",
    ],
  },

  participation: {
    heading: "🤝 तुमचा सहभाग महत्त्वाचा",
    content: "ग्रामपंचायत ही गावकऱ्यांची संस्था आहे. ग्रामसभेत सहभाग महत्त्वाचा आहे.",
  },

  sarpanch: {
    name: "श्री राजेंद्र पांडुरंग पाटील",
    slogan: "👉 प्रत्येक नागरिकाच्या आवाजाला महत्त्व",
    closing: "धाकटी-डहाणू नागरिकांचे प्रेम आणि विश्वास हीच आमची प्रेरणा आहे.",
  },
};

// ================= COMPONENTS =================
const VisionItem = ({ icon, title, description }) => (
  <div className="vision-card">
    <div className="vision-icon">{icon}</div>
    <h4>{title}</h4>
    <p>{description}</p>
  </div>
);

const AboutUs = () => {
  const { sarpanch, facilities } = aboutUsData;

  return (
    <div className="page about-us-page">
      <header className="page-header">
        <h1>{aboutUsData.title}</h1>
        <p>{aboutUsData.intro}</p>
      </header>

      <main>
        {/* Vision */}
        <section className="section">
          <h2>{aboutUsData.visionTitle}</h2>
          <div className="vision-cards-container">
            {aboutUsData.vision.map((item, index) => (
              <VisionItem key={index} {...item} />
            ))}
          </div>
        </section>

        {/* Services */}
        <section className="section">
          <h2>{aboutUsData.servicesTitle}</h2>
          <ul>
            {aboutUsData.services.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </section>

        {/* Gram Panchayat Info */}
        <section className="section bg-light">
          <h2>{aboutUsData.gramPanchayatInfo.title}</h2>
          <div className="gav-info-grid">
            {aboutUsData.gramPanchayatInfo.details.map((item, i) => (
              <div key={i} className="gav-info-card">{item}</div>
            ))}
          </div>
        </section>

        {/* NEW FACILITIES SECTION */}
        <section className="section">
          <h2>{facilities.title}</h2>
          <div className="gav-info-grid">
            {/* Population */}
            <div className="gav-info-card">
              <h3>लोकसंख्या</h3>
              <p><strong style={{fontSize:"28px", color:"#138808"}}>{facilities.population}</strong></p>
              <h3>पुरुष</h3>
              <p><strong style={{fontSize:"28px", color:"#138808"}}>{facilities.male}</strong></p>
              <h3>स्त्रिया</h3>
              <p><strong style={{fontSize:"28px", color:"#138808"}}>{facilities.female}</strong></p>
            </div>

            {/* School */}
            <div className="gav-info-card">
              <h3>शाळा</h3>
              <p>{facilities.school}</p>
            </div>

            {/* Health Center */}
            <div className="gav-info-card">
              <h3>आरोग्य केंद्र</h3>
              <p>{facilities.healthCenter}</p>
            </div>

            {/* Anganwadi */}
            <div className="gav-info-card">
              <h3>अंगणवाडी (3)</h3>
              <ul style={{paddingLeft:"20px", marginTop:"8px"}}>
                {facilities.anganwadi.map((item, i) => (
                  <li key={i} style={{marginBottom:"4px"}}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* Education */}
        <section className="section bg-light">
          <h2>{aboutUsData.education.title}</h2>
          <ul>
            {aboutUsData.education.content.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        </section>

        {/* Participation */}
        <section className="section">
          <h2>{aboutUsData.participation.heading}</h2>
          <p>{aboutUsData.participation.content}</p>
        </section>

        {/* Sarpanch */}
        <section className="section">
          <h2>सरपंच : {sarpanch.name}</h2>
          <p>{sarpanch.slogan}</p>
          <p><strong>{sarpanch.closing}</strong></p>
        </section>
      </main>

      <footer className="page-footer">
        <p>{sarpanch.closing}</p>
      </footer>
    </div>
  );
};

export default AboutUs;